import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { allocationService, attendanceApi, timesheetApi, Util, } from "../../services";
import { DataView, DataViewLayoutOptions } from "primereact/dataview";
import { classNames } from "primereact/utils";
import { useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import properties from "../../config/environmentProperties";
import { ManagerAllocation } from "../allocation/manager-allocation";
import { Sidebar } from "primereact/sidebar";
import { userService } from "../../services/extensions";
import { contactService } from "../../services/profile";
import { Card } from 'primereact/card';
import { Tooltip } from "primereact/tooltip";

function Approvals(props) {
  const [allAllocationApprovals, setAllAllocationApprovals] = useState([]);
  const [allTimesheetApprovals, setAllTimesheetApprovals] = useState([]);
  const [allAttendanceApprovals, setallAttendanceApprovals] = useState([]);
  const [myApprovalList, setMyApprovalList] = useState([]);
  const [layout, setLayout] = useState("grid");
  const navigate = useNavigate();
  const imgPath = properties.currentEnvironment.docPath + "images/";
  const [ac, setAc] = useState(false);
  const [show, setShow] = useState(false);
  const [approvalData, setApprovalData] = useState({});
  const [projects, setProjects] = useState([]);
  const [users, setUsers] = useState([]);
  const [allocationTypes, setAllocationTypes] = useState([]);
  const [userProfileDetails, setUserProfileDetails] = useState({});
  const [timeshetTab, setTimeshetTab] = useState("Recent");
  const options = ["Recent", "Timesheet", "Allocation",];
  const [timesheetTab, setTimesheetTab] = useState(false);

  useEffect(() => {
    changeTimesheetTab({ value: "Recent" });
  }, []);

  useEffect(() => {
    var mergedRecentData = [
      ...allTimesheetApprovals,
      // ...allAllocationApprovals,
      // ...allAttendanceApprovals,
    ];
    setMyApprovalList(mergedRecentData);
  }, [allAllocationApprovals, allTimesheetApprovals, allAttendanceApprovals]);

  const userProfileInfo = (ecn) => {
    let param = { ecn: ecn, };
    contactService.getUserByFilter(param).then((resp) => {
      if (resp) {
        setUserProfileDetails(resp?.data?.data[0]);
      }
    });
  };

  const changeTimesheetTab = (e) => {
    setTimeshetTab(e.value);
    const tab = e.value;
    switch (tab) {
      case "Recent":
        setTimesheetTab(true);
        /* Request allocation start */
        // allocationService.getAllAllocationApprovals().then((resp) => {
        //   try {
        //     let visibleAllocation = [];
        //     resp.data.data.map((el) => {
        //       if (el.Allocation !== null) {
        //         visibleAllocation.push(el);
        //       }
        //       return visibleAllocation;
        //     })
        //     setAllAllocationApprovals(visibleAllocation);
        //   } catch (error) {
        //     // Error handle
        //   }
        // });
        /* Request allocation end */
        timesheetApi.getAllTimesheetApprovals().then((resp) => {
          try {
            setAllTimesheetApprovals(Object.values(resp.data.data));
          } catch (error) {
            // Error handle
          }
        });
        const mergedRecentData = [
          ...allTimesheetApprovals,
          // ...allAllocationApprovals,
          // ...allAttendanceApprovals,
        ];
        setMyApprovalList(mergedRecentData);
        break;
      case "Timesheet":
        setTimesheetTab(true);
        timesheetApi.getAllTimesheetApprovals().then((resp) => {
          setMyApprovalList(Object.values(resp.data.data));
        });
        break;
      case "Attendance":
        attendanceApi.getAllPendingAttendance().then((resp) => {
          let visibleAttendance = [];
          resp.data.data.map((el) => {
            if (el.Attendance !== null) {
              visibleAttendance.push(el);
            }
            return visibleAttendance;
          })
          setMyApprovalList(visibleAttendance);
        });
        break;
      case "Leaves":
        setMyApprovalList([]);
        break;
      default:
        break;
    }
  };

  const renderHeader = () => {
    return (
      <div className="grid grid-nogutter">
        <div className={classNames(layout === "list" ? "col-6 mt-3 mb-3" : "col-6 mt-1")} style={layout === "list" ? { textAlign: "left", paddingLeft: "13px" } : { textAlign: "left" }}>
          <span style={{ fontSize: "18px" }}>My Approvals</span>
          {/* <SelectButton value={timeshetTab} options={options} onChange={(e) => changeTimesheetTab(e)} /> */}
        </div>
        <div className={classNames(layout === "list" ? "col-6 mt-3 mb-3" : "col-6")} style={layout === "list" ? { textAlign: "right", paddingRight: "13px" } : { textAlign: "right" }}>
          <DataViewLayoutOptions layout={layout} onChange={(e) => setLayout(e.value)} />
        </div>
      </div>
    );
  };
  const header = renderHeader();
  const itemTemplate = (myApprovalList, layout) => {
    if (!myApprovalList) {
      return;
    }
    if (layout === "grid") return renderGridItem(myApprovalList);
  };

  const allocateNow = (rowData) => {
    getProjects();
    getUsers();
    getAllocationType();
    setApprovalData(rowData);
    userProfileInfo(rowData.User.ecn);
    setShow(true);
    setAc(true);
  };

  const getProjects = () => {
    allocationService.getActiveProjects().then((resp) => {
      setProjects(resp.data.data);
    });
  };

  const getUsers = () => {
    userService.getUsers().then((resp) => {
      const dataObj = resp.data.data.map((v, i) => ({
        ...v,
        name: resp.data.data[i].firstName + " " + resp.data.data[i].lastName,
      }));
      var activeUsers = [];
      activeUsers = dataObj.filter((i) => {
        return i.status === 1;
      });
      setUsers(activeUsers);
    });
  };

  const getAllocationType = () => {
    allocationService.getAllocationtypes().then((resp) => {
      setAllocationTypes(resp.data.data);
    });
  };

  const managerDashboardReload = () => {
    allocationService.getAllAllocationApprovals().then((resp) => {
      setMyApprovalList(resp.data.data);
    });
  };

  const AddAllocationDialog = () => {
    return (
      <Sidebar className="p-sidebar-md" position="right" visible={show} onHide={() => setShow(false)}>
        <ManagerAllocation projects={projects} users={users} allocationTypes={allocationTypes} setShow={setShow} approveData={approvalData} dashboardReload={managerDashboardReload} userProfileDetails={userProfileDetails} ac={ac} />
      </Sidebar>
    );
  };

  const renderGridItem = (data) => {
    return (
      <div className="col-12 md:col-4 mt-2">
        {AddAllocationDialog()}
        <div className={classNames("mr-2 ml-2", "ess-act-card", "ess-card-theam-2")}>
          <div className="ess-act-header">
            {data.Timesheet && <strong>Timesheet Approval</strong>}
            {data.Allocation && <strong>Allocation Pending</strong>}
          </div>
          <div className="ess-act-body">
            <div className="container">
              {data.Allocation && (
                <p> Allocation Pending for{" "}
                  {data.User && (
                    <>
                      <img alt=" " style={{ height: "30px", width: "30px", borderRadius: "50%", border: "3px solid #d7e9ff", position: "relative", bottom: "-8px" }}
                        src={imgPath + data.User?.photo || ""}
                      />
                      <strong>
                        {data.User.firstName + " " + data.User.lastName}
                      </strong>
                    </>
                  )}
                </p>
              )}
              {timesheetTab ? (
                data.comments !== null ? (
                  <p><strong>{data.firstName + " " + data.lastName}</strong>{" "}Recall Timesheet Request For</p>
                ) : (
                  <p><strong>{data.firstName + " " + data.lastName}</strong>{" "}Filled Timesheet For</p>
                )
              ) : (
                ""
              )}
              <p className="card-date">
                {timesheetTab ? (
                  data.comments !== null ? (
                    <div>
                      <strong className={"custom-tooltip-btn-" + data?.userId + "-" + data?.comments}> {data?.count} {data?.count > 1 ? "Days" : "Day"} <i className="pi pi-info-circle"></i></strong>
                      <Tooltip target={".custom-tooltip-btn-" + data?.userId + "-" + data?.comments}>
                        {
                          data?.date?.filter((i, index) => (index < 10)).map((i, index) => {
                            return (
                              <>
                                <p> {i} </p>
                                <p>{index > 8 ? "... To see more. Click on Review & Approve Now" : ''}</p>
                              </>
                            )
                          })
                        }
                      </Tooltip>
                    </div>
                  ) : (
                    <div>
                      <strong className={"custom-tooltip-btn-" + data.userId}> {data?.count} {data?.count > 1 ? "Days" : "Day"} <i className="pi pi-info-circle"></i></strong>
                      <Tooltip target={".custom-tooltip-btn-" + data.userId}>
                        {
                          data?.date?.filter((i, index) => (index < 10)).map((i, index) => {
                            return (
                              <>
                                <p> {i} </p>
                                <p>{index > 8 ? "... To see more. Click on Review & Approve Now" : ''}</p>
                              </>
                            )
                          })
                        }
                      </Tooltip>
                    </div>
                  )
                ) : (
                  ""
                )}
                {data.Allocation && (
                  <strong>{data.Allocation.Project.title}</strong>
                )}
              </p>
            </div>
            <div className="ess-act-footer">
              <div style={{ float: 'left' }}>
                <a href='#' className='m-link' onClick={() => navigate('/timeline?action=app&id=' + data.userId)}>View Timeline<i className="pi pi-arrow-up-right"></i></a>
              </div>
              {data.Allocation && (
                <div style={{ float: "left" }}></div>
              )}
              <div style={{ textAlign: "right" }}>
                {timesheetTab ? (
                  data.comments !== null ? (
                    <Button label="Review & Approve now" className="p-button-sm p-button-rounded" onClick={() => navigate("/timesheets?action=app&id=" + data.userId + "&status=RECALL")}
                    ></Button>
                  ) : (
                    <Button label="Review & Approve now" className="p-button-sm p-button-rounded" onClick={() => navigate("/timesheets?action=app&id=" + data.userId + "&status=REVIEW")}
                    ></Button>
                  )
                ) : (
                  ""
                )}
                {data.Allocation && (
                  <Button label="Review & Allocate now" className="p-button-sm p-button-rounded" onClick={(e) => allocateNow(data)} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const nameBodyTemplate = (rowData) => {
    return (
      <>
        {rowData.Allocation && (
          <p>Allocation Pending for{" "}
            {rowData.User && (
              <strong>{rowData.User.firstName + " " + rowData.User.lastName}</strong>
            )}
          </p>
        )}

        {timesheetTab ? (
          rowData.comments === null ? (
            <p><strong>{rowData.firstName + " " + rowData.lastName}</strong>{" "}Filled Timesheet</p>
          ) : (
            <p><strong>{rowData.firstName + " " + rowData.lastName}</strong>{" "}Recall Timesheet Request</p>
          )
        ) : (
          ""
        )}
      </>
    );
  };

  const dateBodyTemplate = (rowData) => {
    return (
      <>
        {timesheetTab && (
          <div>
            <strong>{rowData.date.sort()[0] + " - " + rowData.date.sort()[rowData.date.sort().length - 1]}</strong>
          </div>
        )}
        {rowData.Allocation && (
          <strong>{rowData.Allocation.Project.title}</strong>
        )}
      </>
    );
  };

  const statusBodyTemplate = (rowData) => {
    return (
      <>
        {timesheetTab && (
          <div><span style={{ color: "orange" }}><strong>PENDING APPROVAL</strong></span></div>
        )}
        {rowData.Allocation && (
          <div>
            <span>ALLOCATION PENDING</span>
            <span className="" style={{ paddingLeft: "25px" }}></span>
          </div>
        )}
      </>
    );
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <>
        {timesheetTab ? (
          rowData.comments === null ? (
            <Button label="Review & Approve now" className="p-button-sm p-button-rounded" onClick={() => navigate("/timesheets?action=app&id=" + rowData.userId + "&status=REVIEW")}
            ></Button>
          ) : (
            <Button label="Review & Approve now" className="p-button-sm p-button-rounded" onClick={() => navigate("/timesheets?action=app&id=" + rowData.userId + "&status=RECALL")}
            ></Button>
          )
        ) : (
          ""
        )}
        {rowData.Allocation && (
          <Button label="Review & Allocate now" className="p-button-sm p-button-rounded" onClick={(e) => allocateNow(rowData)} />
        )}
      </>
    );
  };

  const timelineBodyTemplate = (rowData) => {
    return (
      <>
        {timesheetTab && (
          <a href='#' className='m-link' onClick={() => navigate('/timeline?action=app&id=' + rowData.userId)}>View Timeline<i className="pi pi-arrow-up-right"></i></a>
        )}
      </>
    );
  };
  return (
    <div className="root">
      <div className="dataview-demo">
        <Card>
          {AddAllocationDialog()}
          {layout === "list" && (
            <DataTable paginator responsiveLayout="scroll"
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rows={10} rowsPerPageOptions={[10, 20, 50]}
              columnResizeMode="fit" scrollable="horizontal" value={myApprovalList} layout={layout} header={header}>
              <Column field="" header="Name" body={nameBodyTemplate}></Column>
              <Column field="" header="Date" body={dateBodyTemplate}></Column>
              <Column field="" header="Status" body={statusBodyTemplate}></Column>
              <Column field="" header="Track Project History" body={timelineBodyTemplate}></Column>
              <Column field="" header="" body={actionBodyTemplate}></Column>
            </DataTable>
          )}

          {layout === "grid" && (
            <DataView paginator responsiveLayout="scroll" paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" rows={10} value={myApprovalList} layout={layout} header={header} itemTemplate={itemTemplate} />
          )}
        </Card>
      </div>
    </div>
  );
}

export default Approvals;